"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BandwidthUtilisation = exports.DEFAULT_UTILISATION = void 0;
var vpt_abr_common_1 = require("@sky-uk-ott/vpt-abr-common");
exports.DEFAULT_UTILISATION = 0.8;
var BandwidthUtilisation = /** @class */ (function () {
    function BandwidthUtilisation(bufferAssessment, config) {
        var _this = this;
        this.bufferAssessment = bufferAssessment;
        this.bufferAhead = 0;
        this.descendingBandwidthUtilisationThreshold = [];
        this.isLowBufferExpected = true;
        this.descendingBandwidthUtilisationThreshold = config.thresholds.sort(function (a, b) { return b.bufferThreshold - a.bufferThreshold; } // DESC
        );
        this.bufferAssessment.addStabilisedBufferChangeListener(function (_a) {
            var bufferAhead = _a.bufferAhead, isLowBufferExpected = _a.isLowBufferExpected;
            _this.bufferAhead = bufferAhead;
            _this.isLowBufferExpected = isLowBufferExpected;
        });
    }
    BandwidthUtilisation.prototype.getRecommendedUtilisation = function () {
        if (!vpt_abr_common_1.ArrayUtils.arrayHasOne(this.descendingBandwidthUtilisationThreshold)) {
            return exports.DEFAULT_UTILISATION;
        }
        var selectedThreshold;
        for (var _i = 0, _a = this.descendingBandwidthUtilisationThreshold; _i < _a.length; _i++) {
            var threshold = _a[_i];
            if (this.bufferAhead >= threshold.bufferThreshold) {
                selectedThreshold = threshold;
                break;
            }
        }
        var lowestThreshold = vpt_abr_common_1.ArrayUtils.last(this.descendingBandwidthUtilisationThreshold);
        if (selectedThreshold === undefined) {
            selectedThreshold = lowestThreshold;
        }
        if (selectedThreshold === lowestThreshold && this.isLowBufferExpected) {
            // If we are on the lowest threshold and this is expected we should return the default.
            return exports.DEFAULT_UTILISATION;
        }
        return this.getUtilisation(selectedThreshold);
    };
    BandwidthUtilisation.prototype.getUtilisation = function (threshold) {
        if ('bandwidthUtilisation' in threshold) {
            return threshold.bandwidthUtilisation;
        }
        var bufferThreshold = threshold.bufferThreshold;
        var _a = threshold.bandwidthUtilisationRange, maxUtilisation = _a.maxUtilisation, minUtilisation = _a.minUtilisation, targetBuffer = _a.targetBufferUpperRange;
        var bufferFullness = (this.bufferAhead - bufferThreshold) / (targetBuffer - bufferThreshold);
        var bandwidthUsage = Math.min(maxUtilisation, minUtilisation + (maxUtilisation - minUtilisation) * bufferFullness);
        return bandwidthUsage;
    };
    return BandwidthUtilisation;
}());
exports.BandwidthUtilisation = BandwidthUtilisation;
